import React from 'react';
import logo from '../../../Assets/userlogo.png'
import classes from './Login.module.css'
import { Button, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Login = () => {
    return (
        <div className={classes.logincontainer}>
            <div className={classes.logocontainer}>
               <Link to={'/'} > <img src={logo}  className={classes.logouser} /></Link>
            </div>

            <div className={classes.loginformcontainer}>
                <div className={classes.loginform}>
                    <div className={classes.loginhead}>
                        <p className={classes.logintxt}>Login</p>
                        <p className={classes.logintxtsml}>We are happy to have you back. Provide the correct information</p>
                    </div>


                    <form className={classes.form} >
                        
                        <div className={classes.inputcontainer}>
                            <label htmlFor="email" className={classes.flnm}>Email address</label>
                            <input type="email" placeholder='Enter email address' required  className={classes.inputform}/>
                        </div>
                        <div className={classes.inputcontainer}>
                            <label htmlFor="password" className={classes.flnm}>Password</label>
                            <input type="password" placeholder='Enter Password' required  className={classes.inputform}/>
                        </div>
                        <p className={classes.forgtpswd}>Forgot password</p>
                       <Link to={'/dashboard'} > <Button variant="primary" type="submit" className={classes.submitbtn}>
                            Login
                        </Button></Link> 
                    </form>

                </div>
            </div>
        </div>
    );
}

export default Login;
